const Link = `
  fragment Link on Link {
    target
    url
  }
`
export default Link
